import { Reveal, Overline } from "./Reveal";
import { CONTACT } from "./data";
import { Check } from "lucide-react";

const POINTS = [
  "Staatlich anerkannter Physiotherapeut",
  "Behandlung ausschließlich als Hausbesuch",
  "Individuelle, zeitlich flexible Termine",
  "Diskret in Ihrer gewohnten Umgebung",
];

export const About = () => (
  <section id="ueber-mich" className="relative bg-[#fafafa] text-[#111] py-24 sm:py-36" data-testid="about">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline className="text-neutral-500">01 — Über mich</Overline>
      </Reveal>

      <div className="grid grid-cols-12 gap-8 lg:gap-14 mt-8 items-start">
        <div className="col-span-12 lg:col-span-4">
          <Reveal>
            <div className="relative max-w-[300px]">
              <div className="absolute -inset-3 bg-neutral-200/70 rounded-sm -z-0 translate-x-3 translate-y-3" />
              <img
                src="/timo-roider.jpg"
                alt="Timo Roider, Physiotherapeut"
                className="relative z-10 w-full aspect-[3/4] object-cover object-top rounded-sm"
                data-testid="about-photo"
              />
              <div className="relative z-10 mt-4 flex items-baseline justify-between">
                <div>
                  <div className="font-grotesk font-bold text-lg">{CONTACT.name}</div>
                  <div className="font-body text-sm text-neutral-500 italic">{CONTACT.role}</div>
                </div>
                <div className="silver-text-dark font-display font-black text-xl">P.M.R.</div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="col-span-12 lg:col-span-8 lg:pt-6">
          <Reveal delay={0.1}>
            <h2 className="font-grotesk font-medium text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
              Physiotherapie, die sich Ihrem Leben anpasst –
              <span className="text-neutral-400"> nicht umgekehrt.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 font-body text-base sm:text-lg text-neutral-600 leading-relaxed max-w-2xl">
              Mein Name ist Timo Roider. Mit P.M.R. – Physio Mobil Roider – bringe ich
              professionelle Physiotherapie direkt zu Ihnen nach Hause. Keine Praxisräume,
              kein Wartezimmer, keine Anfahrt für Sie. Stattdessen volle Aufmerksamkeit,
              Zeit und eine Behandlung, die genau auf Ihre Beschwerden und Ihren Alltag
              zugeschnitten ist.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <ul className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-4">
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3 font-body text-[15px]">
                  <span className="mt-0.5 shrink-0 w-5 h-5 rounded-full bg-[var(--pmr-red)] text-white flex items-center justify-center">
                    <Check size={13} />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
